import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '../../../shared/index';

import { FormElementHbaProfileData } from '../../shared/model/vertical/hba/form-element-hba-profile-data.model';

@Component({
  selector: 'wl-form-builder-hba-profile-data-edit-element',
  templateUrl: 'form-builder-hba-profile-data-edit-element.component.html',
    standalone: false
})
export class FormBuilderHbaProfileDataEditElementComponent {
  private _translationService: TranslationService;

  public hbaProfileDataSettings: FormElementHbaProfileData;

  ngOnInit(): void {
    this.hbaProfileDataSettings = new FormElementHbaProfileData();
  }
}
